import { Button } from "@typedoc/ui";

/**
 * The last resort for a screen that failed to render. It replaces whatever layout failed, shell
 * included, so it is the page's main landmark and the skip link's target itself.
 */
export function RouteError({ onRetry }: { onRetry: () => void }) {
  return (
    <main id="main" className="page">
      <h1>Something went wrong</h1>
      <p className="intro">We couldn't load this page. Please try again.</p>
      <Button onClick={onRetry}>Try again</Button>
    </main>
  );
}
